<style>
  .search-table-outter { overflow-x: scroll; }
  
  </style>

<div class="col-md-12">
  <h3 class="">Report - Payment Details</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />
<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
     
        <form *ngIf="user.Role=='Admin'|| user.Role == 'ReadOnly' || user.Role == 'EndUser'" name="form" (ngSubmit)="getDropAnanlysis()" #f="ngForm" >
        <div class="form">
            <div class="form-group row">
                <label for="UserCai" class="col-sm-2 col-form-label">Employee Name:</label>
                <div class="col-sm-4">
                  {{user.Name}}
                </div>
              </div>
          <div class="form-group row">
                    <label for="SupplierNamelbl"  class="col-sm-2 col-form-label">Supplier AB#</label>
            <div class="col-sm-4">
              <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>         
             </div>
        
            <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
            <div class="col-sm-4">
              <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
            </div>
          </div>
          <div class="form-group row">
            <label for="Arealbl1" class="col-sm-2 col-form-label">Area:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Arealbl1" id="Arealbl1" type="text" class="form-control" [(ngModel)]="Area" [ngbTypeahead]="searchArea"/>
            </div>
         
            <label for="Departmentlbl1" class="col-sm-2 col-form-label">Department:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Departmentlbl1" id="Departmentlbl1" type="text" class="form-control" [(ngModel)]="Department" [ngbTypeahead]="searchDepartment"/>
            </div>
          </div> 
              <div class="form-group row">
                <label for="FromDate" class="col-sm-2 col-form-label">Service From Date:</label>
                  <div class="col-sm-3">
                    <input class="form-control" 
                    name="dpFrom" id="FromDate" [(ngModel)]="FrmDt" ngbDatepicker #d="ngbDatepicker" #dpFrom="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpFrom.invalid }" > 
                    <div *ngIf="f.submitted && dpFrom.invalid" class="invalid-feedback invalid-display">
                     Invalid Date
                    </div> 
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="d.toggle()" type="button"></button>
                   </div>

                   <label for="FromAppDate" class="col-sm-2 col-form-label">Date Approved From:</label>
                <div class="col-sm-3">
                  <input class="form-control" 
                  name="dpAppFrom" id="FromAppDate" [(ngModel)]="FromAppDt" ngbDatepicker #dA="ngbDatepicker" #dpAppFrom="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppFrom.invalid }" > 
                  <div *ngIf="f.submitted && dpAppFrom.invalid" class="invalid-feedback invalid-display">
                   Invalid Date
                  </div> 
                </div>
                 <div class="col-sm-1" style="padding-left: 0px;">
                    <button class="glyphicon glyphicon-calendar" (click)="dA.toggle()" type="button"></button>
                 </div>
                   
              </div>
            <div class="form-group row">
                <label for="ToDate" class="col-sm-2 col-form-label">Service To Date:</label>
                   <div class="col-sm-3">
                    <input class="form-control" 
                    name="dpTo" id="ToDate" [(ngModel)]="ToDt" ngbDatepicker #dt="ngbDatepicker" #dpTo="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpTo.invalid }" > 
                    <div *ngIf="f.submitted && dpTo.invalid" class="invalid-feedback invalid-display">
                     Invalid Date
                    </div> 
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"></button>
                   </div>

                   <label for="ToAppDate" class="col-sm-2 col-form-label">Date Approved To:</label>
                 <div class="col-sm-3">
                  <input class="form-control" 
                  name="dpAppTo" id="ToAppDate" [(ngModel)]="ToAppDt" ngbDatepicker #dAt="ngbDatepicker" #dpAppTo="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppTo.invalid }" > 
                  <div *ngIf="f.submitted && dpAppTo.invalid" class="invalid-feedback invalid-display">
                   Invalid Date
                  </div> 
                </div>
                 <div class="col-sm-1" style="padding-left: 0px;">
                    <button class="glyphicon glyphicon-calendar" (click)="dAt.toggle()" type="button"></button>
                 </div>
                   
            </div>
              
              
                 
            <div class="form-group row">
              <label for="ApprDt" class="col-sm-2 col-form-label">Compliance Approved Date:</label>
                 <div class="col-sm-3">
                  <input class="form-control" 
                  name="dpAppr" id="ApprDt" [(ngModel)]="ApprDt" ngbDatepicker #dtt="ngbDatepicker" #dpAppr="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppr.invalid }" required> 
                  <div *ngIf="f.submitted && dpAppr.invalid" class="invalid-feedback invalid-display">
                    <div *ngIf="dpAppr.errors?.['required']">*Approved date is required</div>
                  </div>
                </div>
                 <div class="col-sm-1" style="padding-left: 0px;">
                    <button class="glyphicon glyphicon-calendar" (click)="dtt.toggle()" type="button"></button>
                 </div>
                 
          </div>
          <div class="form-group row">
            <div class="col-sm-2 col-form-label"></div>
            <div class="col-sm-4">
              
              <button class="btn btn-primary"  >Search</button>
            </div>
          </div>
        </div>
      </form>

      
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  
  <div class="search-table-outter" *ngIf="dropAnalysisResult.length > 0">
  <table class="table table-bordered" width=100% *ngIf="dropAnalysisResult.length > 0">
  
    <thead>
      <tr>
          <th scope="col">Supplier AB#</th>
          <th scope="col">Supplier Name</th>
          <th scope="col" >Object Account</th>
          <th scope="col" >Month/Year</th>
          <th scope ="col">Approved Date</th>
          <th scope="col" >Cost Center</th>
          <th scope="col" >Division Field</th> 
          <th scope="col" >Company Code</th> 
          <th scope="col" >Area</th>
          <th scope="col" >Department</th>
          <th scope="col" >Invoice No.</th>
          <th scope="col" >Invoice</th>
      </tr>
    </thead>
    <tbody *ngIf="dropAnalysisResult.length > 0">
        <tr *ngFor="let _dropres of dropAnalysisResult | paginate: config">
        <td title="Supplier AB#">{{ _dropres.SupplierAB }}</td>
        <td title="Supplier Name">{{ _dropres.SupplierName }}</td>
        <td title="Object Account">{{ _dropres.ObjDescr }}</td>
        <td title="Month/Year">{{ _dropres.Period }}</td>
        <td title="Approved Date">{{ _dropres.ApprovedDate | date: "dd-MM-yyyy"}}</td>
        <td title="Cost Center">{{ _dropres.CostCenter }}</td>
        <td title="Division Field">{{ _dropres.Division }}</td> 
        <td title="Company Code">{{ _dropres.CompanyCode }}</td>
        <td title="Area Details" >{{ _dropres.Area_Code}}-{{ _dropres.Area_description}}</td>
        <td title="Department">{{ _dropres.Division }}</td>
        <td title="Invoice No.">{{ _dropres.InvoiceNo}}</td>
        <td title="Invoice">{{ _dropres.Invoice | currency}}</td>
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="dropAnalysisResult.length > 0" (pageChange)="pageChanged($event)"></pagination-controls>
   </div> 
   <br>
  <div class="form-group row" *ngIf="dropAnalysisResult.length > 0">

    <div class="col-sm-4">
    <button (click)="ExportTOExcel()" class="btn btn-primary">Export to Excel</button>  
    </div>
  </div>  

</div>

<table class="table table-bordered hidden" id="reportGrid_all" *ngIf="dropAnalysisResult.length > 0">
  <col style="width:30%">
  <thead>
    <tr>
      <th scope="col">Supplier AB#</th>
      <th scope="col">Supplier Name</th>
      <th scope="col" >Object Account</th>
      <th scope="col" >Month/Year</th>
      <th scope="col" >Approved Date</th>
      <th scope="col" >Cost Center</th>
      <th scope="col" >Division Field</th> 
      <th scope="col" >Company Code</th> 
      <th scope="col" > Area</th>
      <th scope="col" >Department</th>
      <th scope="col" >Invoice No.</th>
      <th scope="col" >Invoice</th>
    </tr>
  </thead>
  <tbody>
      <tr *ngFor="let _dropres of dropAnalysisResult">
      <td title="Supplier AB#">{{ _dropres.SupplierAB }}</td>
      <td title="Supplier Name">{{ _dropres.SupplierName }}</td>
      <td title="Object Account">{{ _dropres.ObjDescr }}</td>
      <td title="Month/Year">{{ _dropres.Period }}</td>
      <td title="Approved Date">{{ _dropres.ApprovedDate | date:"dd-MM-yyyy"}}</td>
      <td title="Cost Center">{{ _dropres.CostCenter }}</td>
      <td title="Division Field">{{ _dropres.Division }}</td> 
      <td title="Company Code">{{ _dropres.CompanyCode }}</td>
      <td title="Area Details">{{ _dropres.Area_Code}}-{{ _dropres.Area_description}}</td>
      <td title="Department">{{ _dropres.Division}}</td>
      <td title="Invoice No.">{{_dropres.InvoiceNo}}</td>
      <td title="Invoice">{{ _dropres.Invoice | currency}}</td>
    </tr>
  </tbody>
</table>